<template>
	<div class="recover-container">
		<div class="recover-content">
			<!-- Logo -->
			<div class="logo-wrapper">
				<img src="../assets/logo-sc-blanco.svg" alt="Logo" class="logo-img" />
			</div>

			<!-- Recover Card -->
			<div class="recover-card">
				<div class="card-icon">
					<v-icon size="32" color="#6200ea">mdi-lock-reset</v-icon>
				</div>
				<h1 class="card-title">{{ $t('recover.txtResetTitle') || 'Nueva contraseña' }}</h1>
				<p class="card-subtitle">{{ $t('recover.txtResetSubtitle') || 'Ingresa tu nueva contraseña' }}</p>

				<v-form v-model="valid" ref="form" class="recover-form">
					<div class="input-group">
						<label class="input-label">{{ $t('recover.newPassword') }}</label>
						<v-text-field
							v-model="password"
							:type="showPassword ? 'text' : 'password'"
							:rules="passwordRules"
							:placeholder="$t('recover.newPasswordPlaceholder') || 'Mínimo 8 caracteres'"
							required
							outlined
							dense
							hide-details="auto"
							autocomplete="new-password"
							class="modern-input"
						>
							<template v-slot:append>
								<v-icon
									size="20"
									color="#999"
									@click="showPassword = !showPassword"
									style="cursor: pointer;"
								>
									{{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
								</v-icon>
							</template>
						</v-text-field>
					</div>

					<div class="input-group">
						<label class="input-label">{{ $t('recover.repeatPassword') }}</label>
						<v-text-field
							v-model="repeat_password"
							:type="showRepeatPassword ? 'text' : 'password'"
							:rules="passwordRepeatRules"
							:placeholder="$t('recover.repeatPasswordPlaceholder') || 'Repite la contraseña'"
							required
							outlined
							dense
							hide-details="auto"
							autocomplete="new-password"
							class="modern-input"
						>
							<template v-slot:append>
								<v-icon
									size="20"
									color="#999"
									@click="showRepeatPassword = !showRepeatPassword"
									style="cursor: pointer;"
								>
									{{ showRepeatPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
								</v-icon>
							</template>
						</v-text-field>
					</div>

					<button
						type="button"
						class="submit-btn"
						:class="{ 'btn-disabled': !valid || disabled }"
						:disabled="!valid || disabled"
						@click="submit"
					>
						{{ $t('recover.btnUpdatePassword') }}
					</button>
				</v-form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
	data() {
		return {
			valid: false,
			password: "",
			repeat_password: "",
			showPassword: false,
			showRepeatPassword: false,
			passwordRules: [
				(v) => !!v || this.$t("global.rules.passwordRequired"),
			],
			passwordRepeatRules: [
				(v) => !!v || this.$t("global.rules.passwordRequired"),
				(v) =>
					v === this.password ||
					this.$t("global.rules.passwordNoMatch"),
			],
			email: "",
			emailRules: [
				(v) => !!v || this.$t("global.rules.emailRequired"),
				(v) =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					this.$t("global.rules.emailValid"),
			],
			loading: false,
			disabled: false,
			form: {
				token: this.$route.query.token,
				password: "",
				passwordRepeat: "",
			},
		};
	},
	methods: {
		...mapMutations("ui", {
			openSnackbar: "openSnackbar",
		}),
		submit() {
			this.form.password = this.password;
			this.form.passwordRepeat = this.repeat_password;
			this.disabled = true;

			console.log(this.form);

			if (this.$refs.form.validate()) {
				this.$axios
					.post("/auth/update-password", this.form)
					.then(() => {
						this.$router.push({ name: "Login" });
					})
					.catch(() => {
						this.openSnackbar(this.$t('recover.txtErrorUpdate'));
					});
			}
		},
		clear() {
			this.$refs.form.reset();
		},
	},
};
</script>

<style scoped>
.recover-container {
	min-height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.recover-content {
	width: 100%;
	max-width: 360px;
}

.logo-wrapper {
	text-align: center;
	margin-bottom: 28px;
}

.logo-img {
	max-width: 200px;
	height: auto;
}

.recover-card {
	background: #fff;
	border-radius: 16px;
	padding: 28px 24px;
}

.card-icon {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: #ede7f6;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 16px;
}

.card-title {
	font-size: 22px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 4px;
	text-align: center;
}

.card-subtitle {
	font-size: 14px;
	color: #888;
	margin: 0 0 24px;
	text-align: center;
}

.recover-form {
	display: flex;
	flex-direction: column;
}

.input-group {
	margin-bottom: 16px;
}

.input-label {
	display: block;
	font-size: 13px;
	font-weight: 500;
	color: #555;
	margin-bottom: 6px;
}

.modern-input >>> .v-input__slot {
	border-radius: 10px !important;
	min-height: 46px !important;
}

.modern-input >>> .v-text-field__slot input {
	font-size: 14px;
}

.submit-btn {
	width: 100%;
	padding: 14px;
	border: none;
	border-radius: 10px;
	background: #6200ea;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
}

.submit-btn:active {
	transform: scale(0.98);
	background: #5000d0;
}

.btn-disabled {
	background: #ccc;
	cursor: not-allowed;
}

.btn-disabled:active {
	transform: none;
	background: #ccc;
}
</style>
